// 无人机飞行参数设置
export default {
    ET: 'Equipment Type',
    PSDT: 'Please select device type',
    RP: 'Read Parameters',
    WP: 'Write Parameters',
    SP: 'Save Parameters',
    OP: 'Open Parameters',
    NS: 'UAV name/SN',
    ND: 'No Data',
    FP: 'Flight Parameters',
    CUPN: 'Currently used parameter name',
    CUPT: 'Currently used parameter type',
    explain: 'Explain',
    control: 'Control',
    value: 'Value',
    RCS: 'Remote control sensitivity',
    PS: 'Posture sensitivity',
    PN: 'Parameter name',
    PD: 'Parameter description',
    PF: 'Parameter file',
    TIME: 'Time',
    AVL: 'Angular velocity loop',
    AR: 'Angle ring',
    HR: 'Altitude ring',
    PR: 'Position ring',
    AA: 'Altitude acceleration',
    AV: 'Altitude velocity',
    altitude: 'Altitude',
    PS1: 'Position velocity',
    position: 'Position',
    MAJ: 'Maximum acceleration jerk',
    TCSOS: 'The corresponding speed of stroke posture.',
    MinA: 'Minimum acceleration',
    TMAAV: 'The minimum allowable acceleration value for driving or braking in fixed-point mode. The effect is as follows: the movement of small stroke follows the speed.',
    MaxA: 'Maximum acceleration',
    TMAAV2: 'The maximum allowable acceleration value of the stick or brake in fixed-point mode. For slow motion: slow motion.',
    MaxS: 'Maximum speed',
    MAS: 'Maximum allowable speed.',
    MSORC: 'Maximum speed of remote control',
    MARCS: 'Maximum allowable remote control speed.',
    VF: 'Velocity filter',
    AFASF: 'Aircraft fleshed after speed filter cut-off frequency reduced.',
    ACF: 'Acceleration control flag',
    ACHT: 'Acceleration control hover time',
    MAV: 'Maximum acceleration variance',
    tip_PCOV: 'Please check one UAV',
    tip_PSDT: 'Please select device type',
    tip_PCTU: 'Please check the UAV',
    tip_TPCUA: 'The parameters currently used are not consistent with the model. There is a security risk in forcing to write. Do you want to write?',
    tip_DP: 'Delete parameter',
    tip_PEPR: 'Parameter error, please re-enter',
    tip_PSE: 'Parameter setting error',
    tip_UTRAD: 'Unable to recover after deletion. Do you want to continue?',
}